export default __webpack_public_path__ + "static/media/perfil.d27632b1.jpeg";